import { createContext, useContext } from 'react';
import { InfographState } from 'types/infographTypes';

interface InfographStateRendererContextType {
  infographState: InfographState;
}

export const InfographStateRendererContext = createContext<InfographStateRendererContextType | null>(null);

export const useInfographStateRenderer = () => {
  const context = useContext(InfographStateRendererContext);
  return context;
};
